import { ReferenceViewIDParsed, ReferenceViewPropertyIDParsed } from './types.ts';

export function isReferenceViewPropertyIDParsed(
  s: ReferenceViewIDParsed,
): s is ReferenceViewPropertyIDParsed {
  return 'type' in s;
}
